import React from 'react';

const TunerButton: React.FC<{ href: string; onClick: () => void }> = ({
  href,
  onClick,
}) => {
  return (
    <a
      href={href}
      className="cta-button secondary-cta"
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <i className="fas fa-music"></i>
      Free Online Tuner
    </a>
  );
};

export default TunerButton;
